import { State } from '@meraki-internal/state';
import { useEffect, useMemo, useState } from 'react';

/**
 * This is a fork that return TState from the hook instead of IMergedState
 *
 * It also doesn't support subscriptionKey b/c I didn't need that yet
 */

type IStaterGetter<TState extends State> = (...args: any[]) => Promise<TState>;

export function useSubscriptionV2<TState extends State>(getState: IStaterGetter<TState>, subscriptionKey = 'none'): TState | undefined {
    const [reactState, setReactState] = useState<TState | undefined>(undefined);
    const [, setCounter] = useState(1);

    useEffect(() => {
        let unsub: any;

        // Can't use async/await b/c useEffect must return nothing or an unsub function
        Promise.resolve().then(getState)
            .then((state: TState) => {
                setReactState(state);
                unsub = state.subscribe(() => {
                    // if we setReactState again, the reference hasn't changed and react will swallow it
                    setCounter(count => count+1);
                });

                // TODO: handle errors
            });

        return () => {
            if (unsub) {
                unsub();
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subscriptionKey]);

    return reactState;
}

type IStateSyncGetter<TState extends State> = (...args: any[]) => TState;

export function useSubscriptionSync<TState extends State>(getState: IStateSyncGetter<TState>, subscriptionKey = 'none'): TState {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const state = useMemo<TState>(getState, [subscriptionKey]);
    const [, setCounter] = useState(1);

    useEffect(() => {

        const unsub = state.subscribe(() => {
            // if we setReactState again, the reference hasn't changed and react will swallow it
            setCounter(count => count+1);
        });

        return () => {
            if (unsub) {
                unsub();
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subscriptionKey]);

    return state;
}
